export const parseProjectJournalLogMessage = (message = '') => {
  const match = message.match(/\[\[PROJECT_JOURNAL:(\d+):(\d+)\]\]/);
  if (!match) {
    return { text: message, link: null };
  }
  const [token, projectId, entryId] = match;
  return {
    text: message.replace(token, '').trim(),
    link: {
      projectId: Number(projectId),
      entryId: Number(entryId),
    },
  };
};
